import { mapGetters } from "vuex";
export default {
  name: "main-modal",
  props: {},
  computed: {
    ...mapGetters({
      showModal: "modal/show",
      updateKey: "modal/version"
    }),
    bodyBgVariant: function () {
      return this.$store.getters['modal/config']('bodyBgVariant');
    },
    bodyClass: function () {
      return this.$store.getters['modal/config']('bodyClass');
    },
    bodyTextVariant: function () {
      return this.$store.getters['modal/config']('bodyTextVariant');
    },
    busy: function () {
      return this.$store.getters['modal/config']('busy');
    },
    buttonSize: function () {
      return this.$store.getters['modal/config']('buttonSize');
    },
    cancelDisabled: function () {
      return this.$store.getters['modal/config']('cancelDisabled');
    },
    cancelTitle: function () {
      return this.$store.getters['modal/config']('cancelTitle');
    },
    cancelVariant: function () {
      return this.$store.getters['modal/config']('cancelVariant');
    },
    centered: function () {
      return this.$store.getters['modal/config']('centered');
    },
    contentClass: function () {
      return this.$store.getters['modal/config']('contentClass');
    },
    dialogClass: function () {
      return this.$store.getters['modal/config']('dialogClass');
    },
    footerBgVariant: function () {
      return this.$store.getters['modal/config']('footerBgVariant');
    },
    footerBorderVariant: function () {
      return this.$store.getters['modal/config']('footerBorderVariant');
    },
    footerClass: function () {
      return this.$store.getters['modal/config']('footerClass');
    },
    footerTextVariant: function () {
      return this.$store.getters['modal/config']('footerTextVariant');
    },
    fullscreen: function () {
      return this.$store.getters['modal/config']('fullscreen');
    },
    headerBgVariant: function () {
      return this.$store.getters['modal/config']('headerBgVariant');
    },
    headerBorderVariant: function () {
      return this.$store.getters['modal/config']('headerBorderVariant');
    },
    headerClass: function () {
      return this.$store.getters['modal/config']('headerClass');
    },
    headerCloseLabel: function () {
      return this.$store.getters['modal/config']('headerCloseLabel');
    },
    headerCloseWhite: function () {
      return this.$store.getters['modal/config']('headerCloseWhite');
    },
    headerTextVariant: function () {
      return this.$store.getters['modal/config']('headerTextVariant');
    },
    hideBackdrop: function () {
      return this.$store.getters['modal/config']('hideBackdrop');
    },
    hideFooter: function () {
      return this.$store.getters['modal/config']('hideFooter');
    },
    hideHeader: function () {
      return this.$store.getters['modal/config']('hideHeader');
    },
    hideHeaderClose: function () {
      return this.$store.getters['modal/config']('hideHeaderClose');
    },
    id: function () {
      return this.$store.getters['modal/config']('id');
    },
    modalClass: function () {
      return this.$store.getters['modal/config']('modalClass');
    },
    noCloseOnBackdrop: function () {
      return this.$store.getters['modal/config']('noCloseOnBackdrop');
    },
    noCloseOnEsc: function () {
      return this.$store.getters['modal/config']('noCloseOnEsc');
    },
    noFade: function () {
      return this.$store.getters['modal/config']('noFade');
    },
    noFocus: function () {
      return this.$store.getters['modal/config']('noFocus');
    },
    okDisabled: function () {
      return this.$store.getters['modal/config']('okDisabled');
    },
    okOnly: function () {
      return this.$store.getters['modal/config']('okOnly');
    },
    okTitle: function () {
      return this.$store.getters['modal/config']('okTitle');
    },
    okVariant: function () {
      return this.$store.getters['modal/config']('okVariant');
    },
    scrollable: function () {
      return this.$store.getters['modal/config']('scrollable');
    },
    size: function () {
      return this.$store.getters['modal/config']('size');
    },
    title: function () {
      return this.$store.getters['modal/config']('title');
    },
    titleClass: function () {
      return this.$store.getters['modal/config']('titleClass');
    },
    titleSrOnly: function () {
      return this.$store.getters['modal/config']('titleSrOnly');
    },
    titleTag: function () {
      return this.$store.getters['modal/config']('titleTag');
    },
    show: {
      get: function () {
        return this.showModal;
      },
      set: function (value) {
        if (!value) {
          this.$store.dispatch('modal/close');
        } else {
          this.$store.dispatch('modal/open');
        }
      }
    }
  },
  watch: {
    '$route.path': function () {
      this.show = false;
    }
  }
};